var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"NavBar"}},[_c('van-nav-bar',{staticStyle:{"background-color":"#393a3f","color":"white"},attrs:{"title":_vm.title,"left-text":"返回","left-arrow":_vm.isleftarrow},on:{"click-left":_vm.onClickLeft}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }